import { Terms } from "components/Onboarding/Terms/Terms";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/onboarding/terms")({
    component: Terms,
});
